import './PageNotFound.scss'

import React from 'react';

const PageNotFound = () => {
  return (
    <div className="fullscreen">
      <div className="centered">
        <h1 className="error-404">
          404 - Page Not Found
        </h1>
      </div>
    </div>
  )
}

export { PageNotFound };
